let pButt = document.getElementById('passWordSubmit');
let pWord = 'Arbor95';

let pBlock = document.getElementById('passWordBlock');
let pInput = document.getElementById('passWordInput');
let pOnly = pBlock.parentNode.nextSibling;

function hideBlock() {
  pOnly.style.display = 'block';
  pBlock.style.display = 'none';
}

function showBlock() {
  pOnly.style.display = 'none';
  pBlock.style.display = 'block';
}

function checkPassWord() {
  let uPass = pInput.value;
  if (uPass === pWord) {
    hideBlock();
  } else {
    showBlock();
  }
}

window.onload = function() {
  showBlock();
};

pButt.addEventListener('keydown', (event) => {
  if (event.key === "Enter") {
    checkPassWord();
  }
});

pButt.addEventListener('click', () => {
  checkPassWord();
});